type TechnologyContributorStatus = 'active' | 'past';

function parseIsoDate(value: string): Date | null {
  const parts = value.split('-').map(Number);

  if (parts.length !== 3 || parts.some((p) => Number.isNaN(p))) {
    return null;
  }

  const [year, month, day] = parts;
  return new Date(year, month - 1, day);
}

export function getTechnologyContributorStatus(params: {
  contributionsEndDate?: string | null;
}): TechnologyContributorStatus {
  const { contributionsEndDate } = params;

  if (!contributionsEndDate) {
    return 'active';
  }

  const parsedDate = parseIsoDate(contributionsEndDate);

  if (!parsedDate) {
    return 'active';
  }

  const today = new Date();
  const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  return parsedDate < startOfToday ? 'past' : 'active';
}
